import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ customClass, color = 'currentColor' }: IconComponentProps) => <svg width='14' height='16' viewBox='0 0 14 16' class={customClass}>
  <path d='M12.3335 2.00002H11.6668V0.666687H10.3335V2.00002H3.66683V0.666687H2.3335V2.00002H1.66683C0.933496 2.00002 0.333496 2.60002 0.333496 3.33335V14C0.333496 14.7334 0.933496 15.3334 1.66683 15.3334H12.3335C13.0668 15.3334 13.6668 14.7334 13.6668 14V3.33335C13.6668 2.60002 13.0668 2.00002 12.3335 2.00002ZM12.3335 14H1.66683V5.33335H12.3335V14Z' fill={color} />
</svg>
